import classNames from 'classnames'
import { NextSeo } from 'next-seo'

import { msg, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { additional } from '../../../../next-seo.config'
import Wrapper from '../../App/Wrapper'
import styles from './index.module.css'

const PageNotFound = () => (
  <div className={styles.wrapper}>
    <div className="max-w-max mx-auto">
      <main className="sm:flex">
        <p className="text-4xl font-extrabold text-indigo-600 sm:text-5xl">
          404
        </p>
        <div className="sm:ml-6">
          <div className="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              <Trans>Pagina non trovata</Trans>
            </h1>
            <p className="mt-1 text-base text-gray-500">
              <Trans>Questa pagina non &egrave; disponibile.</Trans>
            </p>
          </div>
          <div className="mt-10 flex justify-center items-center space-x-3 sm:border-l sm:border-transparent">
            <a
              href="/"
              className={classNames(
                styles.button,
                'shadow-sm text-white bg-indigo-600 hover:bg-indigo-700'
              )}
            >
              <Trans>Torna alla pagina principale</Trans>
            </a>
          </div>
        </div>
      </main>
    </div>
  </div>
)

const PageNotFoundPage = () => {
  const { _ } = useLingui()

  return (
    <Wrapper>
      <NextSeo title={_(msg`Pagina Non Trovata`)} {...additional} />
      <PageNotFound />
    </Wrapper>
  )
}

export default PageNotFoundPage
